import { render } from "./LegacyWebhookField.vue?vue&type=template&id=42f0e366"
import script from "./LegacyWebhookField.vue?vue&type=script&lang=js"
export * from "./LegacyWebhookField.vue?vue&type=script&lang=js"
script.render = render

export default script